$(document).ready(function(){

  var ids = {},cids = {},designer_url,cur_time;
  cur_time = new Date().getTime();

  //stickey Bar
 if($('.pint-pack-option').length > 0 ) {

  	  var fixmeTop = $('.pint-pack-option').offset().top;
      $(window).scroll(function() {

          var currentScroll = $(window).scrollTop();

          if (currentScroll >= fixmeTop) {
              $('.pint-pack-option').addClass('fixedheader');
          } else {
             $('.pint-pack-option').removeClass('fixedheader');
          }
      });

   	//add class to remove top padding
   	$('#MainContent').addClass('main-content-special');

 }



  //Calculate count of full busket and check which pints will be selected(4/8)


  // selected busket will be filled while page load
  return_real_time_filled_busket()

  if(compare_price_4 != '$0'){
  	$('.pricing-tag').append('<p class="four-pints">1 DOZEN - <strike>'+compare_price_4+'</strike><span>'+regular_price_4+'</span></p>');

  }
  else{
  	$('.pricing-tag').append('<p class="four-pints"1 DOZEN - '+regular_price_4+'</p>');

  }

  if(compare_price_8 != '$0'){
  	$('.pricing-tag').append('<p class="eight-pints">2 DOZEN -  <strike>'+compare_price_8+'</strike><span>'+regular_price_8+'</span></p>');

  }
  else{
  	$('.pricing-tag').append('<p class="eight-pints">2 DOZEN - '+regular_price_8+'</p>');

  }
  
  
  if(compare_price_12 != '$0'){
  	$('.pricing-tag').append('<p class="twelve-pints">3 DOZEN -  <strike>'+compare_price_12+'</strike><span>'+regular_price_12+'</span></p>');

  }
  else{
  	$('.pricing-tag').append('<p class="twelve-pints">3 DOZEN - '+regular_price_12+'</p>');

  }
  
  calculate_remain_pack();
  //Add to pack button event
  $('.ecre-actions #ecre_add_to_pack').click(function(){

        var count = getCount();

        if(count < 18){

            var product_v_id = $(this).parent().parent().children('.pr_id').text();
            var product_id = $(this).parent().parent().children('.grid-view-item__image-wrapper').attr('id');
            var product_name = $(this).parent().parent().children('.visually-hidden:first').text();
            var num = $(".pack-collection ul").find("li").length;
          	var custom_flavor_a;
           //for custom breakable flavor
            var custom_flavor  = $(this).parent().parent().children('.custom_flavor').text();

          //if not any custom flavor defined
          if( custom_flavor == " blank " || custom_flavor == null || custom_flavor == "blank" ){

            custom_flavor_a = product_name;
          } else{

          	custom_flavor_a = custom_flavor;
          }         
            var json_str,result,cjson_str;
          	product_id = product_id.split('-').pop(-1);

//             if(num <= 6){

//               var blank_li = '<li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li>'
//               $('.pack-collection ul#cup').append(blank_li);              

//             }

            $('.pack-collection ul li.blank:first').children().children('img').attr('src','https://cdn.shopify.com/s/files/1/0256/0291/6427/files/cookies-1.png?v=1603877174');
            $('.pack-collection ul li.blank:first').children().children('img').attr('data-id',product_id);
            $('.pack-collection ul li.blank:first').children().children('img').attr('data-vid',product_v_id);
            $('.pack-collection ul li.blank:first').removeClass('blank');

            //add product and set data-id attr in edit pack section
            $('#list_prod').append('<li><a href="javascript:void(0)" data-vid = "'+product_v_id+'" data-id= "'+product_id+'" ><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/delete-button.png?6307"></a><span>'+product_name+'</span></li>');

            ids[product_id] = product_name;

            json_str = JSON.stringify(ids);


            //set product name cookie
            if(getCookie("selected_pints_all") != null){

                result= getCookie("selected_pints_all");
                result = JSON.parse(result);
                result[product_id] = product_name;
                document.cookie = "selected_pints_all="+JSON.stringify(result)+";path="+window.location.pathname;

            }else {

              	document.cookie = "selected_pints_all="+json_str+";path="+window.location.pathname;
            }
            custom_flavor_a = custom_flavor_a.replace(/,/,'#comma');
          	custom_flavor_a = custom_flavor_a.replace(/\./,'#stop');
          	custom_flavor_a = custom_flavor_a.replace(/'/,'#accent');
          	cids[product_id] = custom_flavor_a;

            cjson_str = JSON.stringify(cids);		
          	//set custom flavor name cookie
            if(getCookie("selected_cflavor") != null){

                result= getCookie("selected_cflavor");           
                result = JSON.parse(result);        
                result[product_id] = custom_flavor_a;
                document.cookie = "selected_cflavor="+JSON.stringify(result)+";path="+window.location.pathname;

            }else {
              	document.cookie = "selected_cflavor="+cjson_str+";path="+window.location.pathname;
            }

          	//set cookie for variant id
          	if(getCookie("selected_pints_vid") != null){

              result = getCookie("selected_pints_vid");
              result = result+','+product_v_id;
              document.cookie = "selected_pints_vid="+ result+";path="+window.location.pathname;
            } else{

              document.cookie = "selected_pints_vid=" + product_v_id+";path="+window.location.pathname;
            }


            //set product id cookie
            if(getCookie("selected_pints") != null){

              result = getCookie("selected_pints");
              result = result+','+product_id;
              document.cookie = "selected_pints="+ result+";path="+window.location.pathname;
            } else{

              document.cookie = "selected_pints=" + product_id+";path="+window.location.pathname;
            }

        } else{

            alert("Maximum Cookies Added..");
        }

        calculate_remain_pack()

  });


 //remove product on Busket click
 $(".pack-collection ul#cup").delegate("li", "click", function(){

    if($(this).hasClass('blank')===false) {

      var remove_id = $(this).children().children('img').attr('data-id');
      var remove_vid = $(this).children().children('img').attr('data-vid');
      removeProduct(remove_id,remove_vid);
	}
 });


 ///pints selection radio button click Event

 $('.create-block-radio input[name="pints"]').change(function () {

    var count = getCount();
      var dozen_3 = 18,dozen_2 = 12,dozen_1 = 6;

    if ($(this).val() == '12_pints') {

      var remain = dozen_3 - count;
      $('.label-need-packs p .remain-pack').text(remain);
      $('.label-need-packs p .total-pack').text('3 Dozen');
      $('#cup li:gt(3)').css('display','block');
      
      /*$('#cup li:gt(3)').each(function(){
      	$(this).children().children('img').attr('src','https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140');
      	$(this).addClass('blank');
      });*/

     // $('#list_prod li:gt(3)').remove();


      $('.create-block-radio input.12_pints').prop('checked','checked');
      $('.create-block-radio input.4_pints').prop('checked','');
      $('.create-block-radio input.8_pints').prop('checked','');
      $('.pricing-tag .twelve-pints').css('display','block');
      $('.pricing-tag .eight-pints').css('display','none');
      $('.pricing-tag .four-pints').css('display','none');
      //calculate_remain_pack();


    } else if ($(this).val() == '8_pints') {
      var remain = dozen_2 - count;
      $('.label-need-packs p .remain-pack').text(remain);
      $('.label-need-packs p .total-pack').text('2 Dozen');      
       
      $('.pricing-tag .twelve-pints').css('display','none');
      $('.pricing-tag .eight-pints').css('display','block');
      $('.pricing-tag .four-pints').css('display','none');
     // $('#cup li:gt(7)').css('display','none');
      
  
      if(count > 12){
      	removeProduct(12);
      }
      
      $('#cup li:gt(11)').each(function(){
      	$(this).children().children('img').attr('src','https://cdn.shopify.com/s/files/1/0256/0291/6427/files/cookies-2.png?v=1603877173');
      	$(this).addClass('blank');
      });
     $('#cup li:gt(3)').css('display','block');
     $('#cup li:gt(11)').css('display','none');
	 $('#list_prod li:gt(11)').remove();
      
     $('.create-block-radio input.8_pints').prop('checked','checked');
    //  $('.create-block-radio input.4_pints').prop('checked','');
   
      //calculate_remain_pack();


    } else{

      var remain = dozen_2 - count;
      $('.label-need-packs p .remain-pack').text(remain);
      $('.label-need-packs p .total-pack').text('2 Dozen');
      $('#cup li:gt(5)').css('display','none');
      $('.create-block-radio input.4_pints').prop('checked','checked');
      $('.create-block-radio input.8_pints').prop('checked','');
      $('.pricing-tag .twelve-pints').css('display','none');
      $('.pricing-tag .eight-pints').css('display','none');
      $('.pricing-tag .four-pints').css('display','block');
      
      removeProduct(6);
      $('#cup li:gt(5)').each(function(){
      	$(this).children().children('img').attr('src','https://cdn.shopify.com/s/files/1/0256/0291/6427/files/cookies-2.png?v=1603877173');
      	$(this).addClass('blank');
      });
       $('#list_prod li:gt(3)').remove();
    }


 });


 //Remove pints event while popup open
 $(document).on('click', '#list_prod li a', function(){

    var remove_id = $(this).attr('data-id');
   	var remove_vid = $(this).attr('data-vid');
    removeProduct(remove_id,remove_vid);

 });


 //clear pack
 $('.edit-pack-footer .clear-pack').on('click', function(){
   	$('body').removeClass('position-popup');
	window.location ='#';
 	removeProduct(0);
 });

 //finish Editing
 $('.finish-edit').click(function(){

   	$('body').removeClass('position-popup');
 	window.location ='#';
 });

  $('#edit_pack').click(function(){

    	$('body').addClass('position-popup');
  });

 ///Hide Popup when clicked outside
 $('div#edit_pack_open').on("click", function (event) {
	if ($(event.target).is('.edit-main-wrap')) {

        $('body').removeClass('position-popup');
      	document.location='#'
	}
 });

  //add to cart
  $('#ecre_add_to_cart').click(function(event){
    

    var selected_pints,selected_ids = {},selected_pints_all,product_name,selected_products=[],length,id,quantity,items,final_items,count;
   	var items, final_items,flag=0;
    items = {}; final_items = {};

    if($('.create-block-radio input.12_pints').is(':checked')){

    	status = 1;
    }else if($('.create-block-radio input.8_pints').is(':checked')){

    	status = 2;
    }
    else{
    	status = 0;
    }

    count = getCount();

    if(count < 6 && status == '0'){

      	alert("Please fill 1 Dozen before add to cart");
      	return false;
    }
    else if(count < 12 && status == '2' ){

    	alert("Please fill 2 Dozen before add to cart");
        return false;
    }
    else if(count < 18 && status == '1' ){

    	alert("Please fill 3 Dozen before add to cart");
        return false;
    }

    selected_pints = getCookie('selected_pints');
    selected_pints_all = getCookie('selected_pints_all');
    selected_pints_all = JSON.parse(selected_pints_all)


    length = selected_pints.length;

    for ( i=0; i < length;i++){

      id =  selected_pints[i];
      product_name = selected_pints_all[id];
      selected_products[i] = product_name;

    }
    
//     add_to_cart('999');
    
//     return false;

  console.log('add to cart');
    $.ajax({
        type: "POST",
        url: "https://ecreamery.indiaondesk.com/flavorimage/setflavorimage/index/isAjax/1",
        data: {Pints : selected_products.join(','),product_id : product_id },
        dataType : 'json',
        success: function (data) {
          console.log(data);
          if(data.status == 'success' && data.design_id != '' ){
              add_to_cart(data.design_id);
          }else{
            alert("Something went wrong");
          }
        }
   });

});

  //add product in cart with all its selected flavor.
  function add_to_cart(design_id){

    var selected_pints,selected_ids = {},selected_pints_all,product_name,selected_products=[],length,id,quantity,items,final_items,count;

    selected_pints_all = getCookie('selected_pints_all');
    selected_pints = getCookie('selected_pints');
    selected_pints_all = JSON.parse(selected_pints_all)

    length = selected_pints.length;

    for ( i=0; i < length;i++){

      id =  selected_pints[i];
      product_name = selected_pints_all[id];
      selected_products[i] = product_name;

    }

    selected_pints.forEach(function(element){

        if (!selected_ids[element]) {
            selected_ids[element] = 0;
        }

        selected_ids[element] += 1;
    });

    selected_ids = JSON.stringify(selected_ids);

    if(getCount() <= 6){
      	variant_id = pint_4_id;
    }else if(getCount() <= 12){
    	variant_id = pint_8_id;
    }else{
       variant_id = pint_12_id;
    }

    var params = {
                  quantity: 1,
                  id: variant_id
                };

    			properties = {
                  'Cookies' : selected_products.join(', '),
                  '_Selected Ids' : selected_ids,
                  '_Product Design'	: design_id,
                  '_Individual Product' : 'Yes',
                  'Product Design': 'No',
                };

                if(properties != false){
                  params.properties = properties;
                }

    jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: params,
          success: function( response ){
			window.location='/cart/';
            document.cookie = "selected_pints= ; expires = Thu, 01 Jan 1970 00:00:00 GMT;path="+window.location.pathname;
        	document.cookie = "selected_pints_vid= ; expires = Thu, 01 Jan 1970 00:00:00 GMT;path="+window.location.pathname;
          },
          error: function( XMLHttpRequest, textStatus, errorThrown ) {
            response = JSON.parse(XMLHttpRequest.responseText)

            result = response['description'];
            alert(result.replace(' already ',' '));
           }
          });

}

  //Click on Personalise Button

  $('.add-cart-stock .personalise').click(function(){

 	var variant_id,id,count,product_name,selected_ids = {},selected_products = {},length,selected_pints,selected_flavors={},selected_pints_all,selected_cflavor;
    var cflavor_name,final_data = [];
    if($('.create-block-radio input.12_pints').is(':checked')){

    	status = 1;
    }else if($('.create-block-radio input.8_pints').is(':checked')){

    	status = 2;
    }
    else{
    	status = 0;
    }

    count = getCount();

    if(count < 6 && status == '0'){

      	alert("Please fill 1 Dozen before Personalizing");
      	return false;
    }
    else if(count < 12 && status == '2' ){

    	alert("Please fill 2 Dozen before Personalizing");
        return false;
    }
    else if(count < 18 && status == '1' ){

    	alert("Please fill 3 Dozen before Personalizing");
        return false;
    }
    

    selected_pints_all = getCookie('selected_pints_all');
    selected_cflavor = getCookie('selected_cflavor');
    selected_pints = getCookie('selected_pints');
    
    length = selected_pints.length;

    if ( selected_pints_all != null ) {
      selected_pints_all = JSON.parse( selected_pints_all );
    }
    if ( selected_cflavor != null ) {
      selected_cflavor = JSON.parse( selected_cflavor );
    }

    for (var i=0; i < length;i++){
      var tmp_data = {}
      id = selected_pints[i];
      product_name = selected_pints_all[id];
      selected_products[i] = product_name;
      cflavor_name = selected_cflavor[id];
      
      cflavor_name = cflavor_name.replace(/#comma/,',');
      cflavor_name = cflavor_name.replace(/#stop/,'.');
      cflavor_name = cflavor_name.replace(/#accent/,'`');
      selected_flavors[i] = cflavor_name;
      tmp_data['id'] = id;
      tmp_data['title'] = product_name;
      tmp_data['custom_title'] = cflavor_name;

      final_data[i] = tmp_data;
    }

    final_data = JSON.stringify(final_data);

    selected_pints.forEach(function(element) {

        if (!selected_ids[element]) {
            selected_ids[element] = 0;
        }

        selected_ids[element] += 1;
    });

    //convert data in json
    selected_products = JSON.stringify(selected_products);
    selected_ids = JSON.stringify(selected_ids);
    
    if(getCount() <= 6){
      	variant_id = pint_4_id;
    }else if(getCount() <= 12){
    	variant_id = pint_8_id;
    }else{
       variant_id = pint_12_id;
    }

    $('#selected_ids').val(window.btoa(selected_ids));
    $('#selected_custom_flavor').val(window.btoa(final_data));
    $('#selected_products').val(window.btoa(selected_products));
    $('#current_timestamp').val(window.btoa(cur_time));
    $('#sid').val(window.btoa(variant_id));
    $('#ecre-final-data').attr('action',base_url);


    $('form#ecre-final-data').submit();


    //empty selected bucket
    document.cookie = "selected_pints= ; expires = Thu, 01 Jan 1970 00:00:00 GMT;path="+window.location.pathname;
    document.cookie = "selected_pints_vid= ; expires = Thu, 01 Jan 1970 00:00:00 GMT;path="+window.location.pathname;

  });



equalheight = function(container){

  var currentTallest = 0,
       currentRowStart = 0,
       rowDivs = new Array(),
       $el,
       topPosition = 0;
   $(container).each(function() {

     $el = $(this);
     $($el).height('auto')
     topPostion = $el.position().top;

     if (currentRowStart != topPostion) {
       for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
         rowDivs[currentDiv].height(currentTallest);
       }
       rowDivs.length = 0; // empty the array
       currentRowStart = topPostion;
       currentTallest = $el.height();
       rowDivs.push($el);
     } else {
       rowDivs.push($el);
       currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
    }
     for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
       rowDivs[currentDiv].height(currentTallest);
     }
   });
}

$(window).load(function() {
  equalheight('.grid-view-item__image-wrapper.product-card__image-wrapper');
});


$(window).resize(function(){
  equalheight('.grid-view-item__image-wrapper.product-card__image-wrapper');
});


});


//Get the stored cookie
function getCookie(name) {

  var get_data,result = null;

  get_data = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

  if( get_data != null){

    result = get_data[2].split(',');
  }

  return result;

}


//Count stored cookie length
function getCount(){

  var result,length = null;
  result = getCookie("selected_pints_vid");

  if(result != null){
  	length = result.length;
  }

  return length;
}


//Remove product from list and cookie
function removeProduct(remove_id,remove_vid){

  var length,result,value,v_result,v_id;
  length = getCount();
  result = getCookie("selected_pints");
  v_result = getCookie("selected_pints_vid");

  if(remove_id != 0){

    if(remove_id == 6){

      result.splice(6);
      v_result.splice(6);
    }else if(remove_id == 12){
      result.splice(12);
      v_result.splice(12);
    }else{

       $('#list_prod li a[data-id="'+remove_id+'"]').each(function(i) {

       if(i == 0 ){

            $(this).parent().remove();
            return false;
          }
       });

        $('.pack-collection ul li a img[data-id="'+remove_id+'"]').each(function(i) {

          if(i == 0 ){

            $(this).parent().parent().remove();
            return false;
          }
        });



        //Append new blank bucket
        $('.pack-collection ul#cup').append('<li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0256/0291/6427/files/cookies-2.png?v=1603877173"></a></li>');

        for (var i=0; i < length;i++){

          value = result[i];
          v_id = v_result[i];

          if(value == remove_id && v_id == remove_vid ){
            result.splice(i, 1);
            v_result.splice(i, 1);
            break;
          }

        }
      	//window.location ='#';
    }

    result.join();
    v_result.join();

    document.cookie = "selected_pints= ; expires = Thu, 01 Jan 1970 00:00:00 GMT;path="+window.location.pathname;
    document.cookie = "selected_pints_vid= ; expires = Thu, 01 Jan 1970 00:00:00 GMT;path="+window.location.pathname;


    if(result != ''){
   	   document.cookie = "selected_pints="+result+";path="+window.location.pathname;
    }
    if(v_result != ''){
   	   document.cookie = "selected_pints_vid="+v_result+";path="+window.location.pathname;
    }
  }

  else{

   //In case of remove all products
   $('#list_prod li').remove();
   $('.pack-collection ul li').remove();

   var blank_li = '<li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0256/0291/6427/files/cookies-2.png?v=1603877173"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0256/0291/6427/files/cookies-2.png?v=1603877173"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0256/0291/6427/files/cookies-2.png?v=1603877173"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0256/0291/6427/files/cookies-2.png?v=1603877173"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0256/0291/6427/files/cookies-2.png?v=1603877173"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0256/0291/6427/files/cookies-2.png?v=1603877173"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0256/0291/6427/files/cookies-2.png?v=1603877173"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0256/0291/6427/files/cookies-2.png?v=1603877173"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0256/0291/6427/files/cookies-2.png?v=1603877173"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0256/0291/6427/files/cookies-2.png?v=1603877173"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0256/0291/6427/files/cookies-2.png?v=1603877173"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0256/0291/6427/files/cookies-2.png?v=1603877173"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0256/0291/6427/files/cookies-2.png?v=1603877173"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0256/0291/6427/files/cookies-2.png?v=1603877173"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0256/0291/6427/files/cookies-2.png?v=1603877173"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0256/0291/6427/files/cookies-2.png?v=1603877173"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0256/0291/6427/files/cookies-2.png?v=1603877173"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0256/0291/6427/files/cookies-2.png?v=1603877173"></a></li>'
   $('.pack-collection ul#cup').append(blank_li);
   document.cookie = "selected_pints= ; expires = Thu, 01 Jan 1970 00:00:00 GMT;path="+window.location.pathname;
   document.cookie = "selected_pints_vid= ; expires = Thu, 01 Jan 1970 00:00:00 GMT;path="+window.location.pathname;
  }
  calculate_remain_pack(1);

}

//Return remaining bucket count
function calculate_remain_pack(data){
	var remain,dozen_3 = 18,dozen_2 = 12,dozen_1 = 6,count,pints;
    count = getCount();
  
    //top bar show hide
    if(count != null){

      	$('#MainContent .pint-pack-option').css('display','block');

    } else{

      	$('.create-block-radio input.4_pints').prop('checked','checked');
        $('.create-block-radio input.8_pints').prop('checked','');
      	$('#MainContent .pint-pack-option').css('display','none');
    }
  
  	if( $('.create-block-radio input.12_pints:checked').length == 1 ){
      if(count <= 12 && data == '1'){		
      	remain = dozen_2 - count;
      	$('.label-need-packs p .remain-pack').text(remain);
      	$('.label-need-packs p .total-pack').text('2 Dozen')
     	$('#cup li:gt(3)').css('display','block');
        $('#cup li:gt(11)').css('display','none');
      	$('.create-block-radio input.8_pints').prop('checked','checked');
      	$('.create-block-radio input.12_pints').prop('checked','');
      	$('.pricing-tag .twelve-pints').css('display','none');
        $('.pricing-tag .eight-pints').css('display','block');
        $('.pricing-tag .four-pints').css('display','none');

      } 
      else{	
        remain = dozen_3 - count;
	  	$('.label-need-packs p .remain-pack').text(remain);
      	$('.label-need-packs p .total-pack').text('3 Dozen');
      	$('#cup li:gt(11)').css('display','block'); 
      	$('.create-block-radio input.12_pints').prop('checked','checked');
      	$('.create-block-radio input.4_pints').prop('checked','');
      	$('.pricing-tag .twelve-pints').css('display','block');
        $('.pricing-tag .eight-pints').css('display','none');
        $('.pricing-tag .four-pints').css('display','none');

      }
    }else if(count > 12){ 
      remain = dozen_3 - count;
	  $('.label-need-packs p .remain-pack').text(remain);
      $('.label-need-packs p .total-pack').text('3 Dozen');
      $('#cup li:gt(11)').css('display','block');  
     // $('#cup li:gt(7)').css('display','none');
      $('.create-block-radio input.12_pints').prop('checked','checked');
      $('.create-block-radio input.4_pints').prop('checked','');
      $('.create-block-radio input.8_pints').prop('checked','');
      $('.pricing-tag .twelve-pints').css('display','block');
      $('.pricing-tag .eight-pints').css('display','none');
      $('.pricing-tag .four-pints').css('display','none');
      
    }else if(count <= 12){
      remain = dozen_2 - count;
	  $('.label-need-packs p .remain-pack').text(remain);
      $('.label-need-packs p .total-pack').text('2 Dozen');
      $('#cup li:gt(6)').css('display','block'); 
      $('#cup li:gt(11)').css('display','none');
      $('.create-block-radio input.8_pints').prop('checked','checked');
      $('.create-block-radio input.4_pints').prop('checked','');
      $('.pricing-tag .twelve-pints').css('display','none');
      $('.pricing-tag .eight-pints').css('display','block');
      $('.pricing-tag .four-pints').css('display','none');

    }else if( $('.create-block-radio input.8_pints:checked').length == 1 ){      
     

     /* if(count <= 6 && data == '1'){

      	remain = dozen_2 - count;
      	$('.label-need-packs p .remain-pack').text(remain);
      	$('.label-need-packs p .total-pack').text('3 Dozen')
     	//$('#cup li:gt(5)').css('display','none');
        $('#cup li:gt(11)').css('display','none');
      	$('.create-block-radio input.4_pints').prop('checked','checked');
      	$('.create-block-radio input.8_pints').prop('checked','');
      	$('.pricing-tag .twelve-pints').css('display','none');
        $('.pricing-tag .eight-pints').css('display','none');
        $('.pricing-tag .four-pints').css('display','block');

      }
      else{

        remain = dozen_2 - count;
	  	$('.label-need-packs p .remain-pack').text(remain);
      	$('.label-need-packs p .total-pack').text('2 Dozen');
      	$('#cup li:gt(3)').css('display','block'); 
        $('#cup li:gt(11)').css('display','none');
      	$('.create-block-radio input.8_pints').prop('checked','checked');
      	$('.create-block-radio input.4_pints').prop('checked','');
      	$('.pricing-tag .twelve-pints').css('display','none');
        $('.pricing-tag .eight-pints').css('display','block');
        $('.pricing-tag .four-pints').css('display','none');

      } */
    }else{
      
      remain = dozen_1 - count;
      $('.label-need-packs p .remain-pack').text(remain);
      $('.label-need-packs p .total-pack').text('1 Dozen')
      $('#cup li:gt(6)').css('display','block');
      $('#cup li:gt(11)').css('display','none');
      $('.create-block-radio input.4_pints').prop('checked','checked');
      $('.create-block-radio input.8_pints').prop('checked','');
      $('.pricing-tag .twelve-pints').css('display','none');
      $('.pricing-tag .eight-pints').css('display','none');
      $('.pricing-tag .four-pints').css('display','block');

    }



  	//Show currently availabe pints in popup
    if(count == null){

      pints = 0;
    } else{

      pints = count;
    }

  	$('.current-pack-wrapper').html('<span>'+pints+' Cookies Pairs in Pack</span>');


  	if($('.create-block-radio input.4_pints').is(':checked')) {

    	$('#cup li:lt(6)').css('display','block');
    	return true;
    } else{

    	return false;
  	}
 }

//Remain filled while page refresh
function return_real_time_filled_busket(){

	if(getCookie("selected_pints") != null){
  	  var value,result,selected_pints_all,length,product_name,v_id,v_result;
      result = getCookie("selected_pints");
      v_result = getCookie("selected_pints_vid");
      selected_pints_all = getCookie("selected_pints_all");
      length = getCount();

      if ( selected_pints_all != null ) {
        selected_pints_all = JSON.parse( selected_pints_all );
      }

      for (var i=0; i < length;i++){

        value = result[i];
        v_id = v_result[i];
        $('.pack-collection ul li.blank:first').children().children('img').attr('src','https://cdn.shopify.com/s/files/1/0256/0291/6427/files/cookies-1.png?v=1603877174');
        $('.pack-collection ul li.blank:first').children().children('img').attr('data-id',value);
        $('.pack-collection ul li.blank:first').children().children('img').attr('data-vid',v_id);
        $('.pack-collection ul li.blank:first').removeClass('blank');

        if(selected_pints_all != null){

          product_name = selected_pints_all[value];
        }

        $('#list_prod').append('<li><a href="javascript:void(0)" data-vid = "'+v_id+'" data-id= "'+value+'" ><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/delete-button.png?6307"></a><span>'+product_name+'</span></li>');
      }

  }

}